var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_700, BLUE_500, Button, Dropdown, getTestId, IconButton, InfoTag, RightChevronIcon, StateConfigContext, Tooltip, Typography } from '@airtel/air-design-system';
import { useContext, useState } from 'react';
import { Pressable, View } from 'react-native';
import { getTableCellStyles } from './TableCellStyles';
export var TableCell = props => {
  var _useContext = useContext(StateConfigContext),
    theme = _useContext.theme;
  var heading = props.heading,
    headingAsBold = props.headingAsBold,
    headingAsLink = props.headingAsLink,
    onHeadingPress = props.onHeadingPress,
    subHeading = props.subHeading,
    subHeadingBold = props.subHeadingBold,
    subHeadingAsLink = props.subHeadingAsLink,
    onSubHeadingPress = props.onSubHeadingPress,
    infoTagText = props.infoTagText,
    infoTagType = props.infoTagType,
    _props$infoTagSize = props.infoTagSize,
    infoTagSize = _props$infoTagSize === void 0 ? 'md' : _props$infoTagSize,
    ctaText = props.ctaText,
    _props$ctaSize = props.ctaSize,
    ctaSize = _props$ctaSize === void 0 ? 'sm' : _props$ctaSize,
    onCtaPress = props.onCtaPress,
    showIcon = props.showIcon,
    style = props.style,
    _props$actionIcons = props.actionIcons,
    actionIcons = _props$actionIcons === void 0 ? [] : _props$actionIcons,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'TableCell' : _props$testID,
    showDropdown = props.showDropdown,
    dropdownMenuData = props.dropdownMenuData,
    contextMenuIconPressHandler = props.contextMenuIconPressHandler,
    onActionIconPress = props.onActionIconPress,
    onDropdownItemPress = props.onDropdownItemPress,
    tooltipProps = props.tooltipProps,
    showToolTipOnHeading = props.showToolTipOnHeading,
    _props$headingNumberO = props.headingNumberOfLines,
    headingNumberOfLines = _props$headingNumberO === void 0 ? 3 : _props$headingNumberO,
    maxWidthToBreakAll = props.maxWidthToBreakAll,
    headingStyle = props.headingStyle;
  var tableStyles = getTableCellStyles();
  var _useState = useState(false),
    showToolTip = _useState[0],
    setShowToolTip = _useState[1];
  var headingColor = headingAsLink && BLUE_500;
  if (theme == 'white') {
    headingColor = BLACK_700;
  }
  var Wrapper = _ref => {
    var isLink = _ref.isLink,
      onHandlePress = _ref.onHandlePress,
      onPressProps = _ref.onPressProps,
      children = _ref.children;
    return isLink || !!heading && showToolTipOnHeading ? _jsx(Pressable, Object.assign({
      onPress: () => {
        !!heading && showToolTipOnHeading && setShowToolTip(!showToolTip);
        isLink && (onHandlePress === null || onHandlePress === void 0 ? void 0 : onHandlePress(onPressProps));
      },
      onHoverIn: () => {
        !!heading && showToolTipOnHeading && setShowToolTip(true);
      },
      onHoverOut: () => {
        !!heading && showToolTipOnHeading && setShowToolTip(false);
      }
    }, {
      children: children
    })) : _jsx(_Fragment, {
      children: children
    });
  };
  var isWordBreakAllApplicable = !maxWidthToBreakAll || maxWidthToBreakAll && parseInt(style['minWidth']) <= parseInt(maxWidthToBreakAll);
  return _jsxs(View, Object.assign({
    style: [tableStyles.container, style, (actionIcons === null || actionIcons === void 0 ? void 0 : actionIcons.length) > 0 && (tableStyles === null || tableStyles === void 0 ? void 0 : tableStyles.actionsContainer)]
  }, getTestId(testID), {
    children: [(!!heading || !!subHeading || !!infoTagText || !!ctaText) && _jsxs(View, Object.assign({
      style: [tableStyles.cellContainer, style['minWidth'] && isWordBreakAllApplicable && tableStyles.variableWidth]
    }, getTestId('cellContainer'), {
      children: [heading && _jsx(Tooltip, Object.assign({
        style: {
          flex: 1,
          zIndex: 1
        },
        position: "bottom-start",
        autoHide: true,
        isVisible: showToolTip
      }, tooltipProps, {
        onClose: () => {
          if (tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.autoHide) {
            setShowToolTip(false);
          }
        }
      }, getTestId(testID, 'tooltip'), {
        children: _jsx(Wrapper, Object.assign({
          isLink: headingAsLink,
          onHandlePress: onHeadingPress,
          onPressProps: props
        }, {
          children: _jsx(Typography, Object.assign({
            type: "body-para-sm",
            text: heading,
            theme: theme,
            color: headingColor,
            style: headingStyle,
            isBold: (headingAsBold === null || headingAsBold === void 0 ? void 0 : headingAsBold.length) > 0 || headingAsLink,
            numberOfLines: headingNumberOfLines
          }, getTestId(testID, 'heading')))
        }))
      })), (subHeading || subHeadingBold) && _jsxs(Wrapper, Object.assign({
        isLink: subHeadingAsLink,
        onHandlePress: onSubHeadingPress,
        onPressProps: props
      }, {
        children: [subHeading && _jsx(Typography, Object.assign({
          type: "body-para-xs",
          color: subHeadingAsLink && BLUE_500,
          style: tableStyles.subHeading,
          text: subHeading
        }, getTestId(testID, 'subHeading'))), subHeadingBold && _jsx(Typography, Object.assign({
          type: "body-para-sm-bold",
          style: tableStyles.subHeading,
          text: subHeadingBold,
          isBold: true
        }, getTestId(testID, 'subHeadingBold')))]
      })), infoTagText && _jsx(InfoTag, Object.assign({
        style: tableStyles.infoTagText,
        text: infoTagText,
        subType: infoTagType,
        size: infoTagSize
      }, getTestId(testID, 'infoTagText'))), ctaText && _jsx(Button, Object.assign({
        size: ctaSize,
        style: tableStyles.cta,
        buttonType: "tertiary",
        title: ctaText,
        onPress: () => {
          onCtaPress(props);
        }
      }, getTestId(testID, 'ctaText')))]
    })), showIcon && _jsx(RightChevronIcon, Object.assign({
      style: tableStyles.icon,
      fontSize: 16,
      color: BLUE_500
    }, getTestId(testID, 'showIcon'))), actionIcons === null || actionIcons === void 0 ? void 0 : actionIcons.map((actionIconProps, idx) => {
      var id = actionIconProps.id,
        _onPress = actionIconProps.onPress,
        iconButtonProps = __rest(actionIconProps, ["id", "onPress"]);
      return _jsx(View, Object.assign({
        style: tableStyles.actionIconsContainer
      }, {
        children: _jsx(IconButton, Object.assign({
          type: "secondary",
          onPress: () => {
            onActionIconPress({
              onPress: _onPress,
              selectedItem: actionIconProps
            });
          }
        }, iconButtonProps))
      }), id || idx);
    }), showDropdown && _jsx(Pressable, Object.assign({
      onPress: () => {
        contextMenuIconPressHandler === null || contextMenuIconPressHandler === void 0 ? void 0 : contextMenuIconPressHandler(showDropdown, props);
      }
    }, {
      children: _jsx(Dropdown, Object.assign({}, dropdownMenuData, {
        parentType: "icon",
        onSelectedHandler: function onSelectedHandler() {
          for (var _len = arguments.length, dropdownSelectedHandlerArgs = new Array(_len), _key = 0; _key < _len; _key++) {
            dropdownSelectedHandlerArgs[_key] = arguments[_key];
          }
          var item = dropdownSelectedHandlerArgs[2];
          if (typeof dropdownMenuData.onSelectedHandler === 'function') {
            dropdownMenuData.onSelectedHandler(...dropdownSelectedHandlerArgs);
          }
          onDropdownItemPress === null || onDropdownItemPress === void 0 ? void 0 : onDropdownItemPress({
            selectedItem: item
          });
        }
      }))
    }))]
  }));
};